export default __webpack_public_path__ + "static/media/greatnovel.0334a23f.png";